/**
 * AssessmentConfigAlert Component
 * Displays next scheduled assessment info
 * Extracted from Assessments.js for better code organization
 */
import { Card } from '../ui/card';
import { Clock } from 'lucide-react';

const AssessmentConfigAlert = ({ config }) => {
  if (!config?.proxima_avaliacao) return null;

  return (
    <Card className="p-4 bg-blue-50 dark:bg-blue-950 border-blue-200" data-testid="config-alert">
      <div className="flex items-center gap-3">
        <Clock size={24} className="text-blue-600" />
        <div>
          <p className="font-semibold text-blue-900 dark:text-blue-100">
            Próxima Avaliação Periódica: {new Date(config.proxima_avaliacao).toLocaleDateString('pt-BR')}
          </p>
          <p className="text-sm text-blue-700 dark:text-blue-300">
            Frequência configurada: {config.frequencia} | Aviso com {config.dias_antecedencia_aviso} dias de antecedência
          </p>
        </div>
      </div>
    </Card>
  );
};

export default AssessmentConfigAlert;
